module.exports = __webpack_public_path__ + "assets/img/4_103_big.534923e1.jpg";